// extracted by mini-css-extract-plugin
export default {"titleWrapper":"Subtitle_titleWrapper__sdbwJ","infoIcon":"Subtitle_infoIcon__hKQWD","info":"Subtitle_info__ync0X","wrapper":"Subtitle_wrapper__w0PCX","title":"Subtitle_title__2m70G"};